import { message, Table } from "antd";
import React, { useEffect, useState } from "react";
import atollService from "@services/atoll.services";

const Roles = () => {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  // eslint-disable-next-line
  const [error, setError] = useState(null);

  const fetcher = async () => {
    setLoading(true);
    try {
      const { data } = await atollService.fetchRoles({});
      console.log("data", data[0]);
      setList(data[0]);
    } catch (error) {
      message.error("Action has error",20);
      console.log(error);
      setError(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetcher();
  }, []);

  return (
    <div className="p-5">
      <Table
        dataSource={list}
        loading={loading}
        columns={[
          {
            title: "Username",
            dataIndex: "UserName",
            key: "UserName",
          },
          {
            title: "Role",
            dataIndex: "Role",
            key: "Role",
          },
        ]}
      />
    </div>
  );
};

export default Roles;
